import { createContext, useContext, RefObject } from 'react'

type AnnotationsContextType = {
  annotationsCanvasRef: RefObject<HTMLDivElement | null> | null
  setIsResizing: (isResizing: boolean) => void
  isOutOfBounds: boolean
  setIsOutOfBounds: (isOutOfBounds: boolean) => void
}

export const AnnotationsContext = createContext<AnnotationsContextType>({
  annotationsCanvasRef: null,
  setIsResizing: () => {},
  isOutOfBounds: false,
  setIsOutOfBounds: () => {},
})

export const useAnnotationsContext = () => useContext(AnnotationsContext)

export const AnnotationsProvider = ({
  children,
  annotationsCanvasRef,
  setIsResizing,
  isOutOfBounds,
  setIsOutOfBounds,
}: {
  children: React.ReactNode
  annotationsCanvasRef: RefObject<HTMLDivElement | null>
  setIsResizing: (isResizing: boolean) => void
  isOutOfBounds: boolean
  setIsOutOfBounds: (isOutOfBounds: boolean) => void
}) => {
  return (
    <AnnotationsContext.Provider
      value={{
        setIsResizing,
        isOutOfBounds,
        setIsOutOfBounds,
        annotationsCanvasRef,
      }}
    >
      {children}
    </AnnotationsContext.Provider>
  )
}
